import { useController } from '@tokamakjs/react';

import { ChangePassword, RequestReset } from './components';
import { ResetPasswordController } from './reset-password.controller';

export const ResetPasswordView = () => {
  const controller = useController<ResetPasswordController>();

  return controller.code ? (
    <ChangePassword controller={controller} />
  ) : (
    <RequestReset controller={controller} />
  );
};
